import {
    HttpResponse,
    ProductCollectionModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ProductCollectionsDataService implements CrudService<ProductCollectionModel, ProductCollectionModel> {
    getAll(query: CrudDataQuery<ProductCollectionModel>): Promise<CrudEnumerableResponse<ProductCollectionModel>> {
        return ApiService.api.getProductCollectionBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ProductCollectionModel>): Promise<CrudEnumerableResponse<ProductCollectionModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ProductCollectionModel>> {
        return ApiService.api.getProductCollectionById(id, params);
    }

    create(item: ProductCollectionModel, params?: RequestParams): Promise<CrudResponse<ProductCollectionModel>> {
        return ApiService.api.insertProductCollection(item, params);
    }

    update(item: ProductCollectionModel, params?: RequestParams): Promise<ProductCollectionModel> {
        return ApiService.api.updateProductCollection(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ProductCollectionModel> {
        return ApiService.api.patchProductCollection(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ProductCollectionModel>): Promise<CrudEnumerableResponse<ProductCollectionModel>> {
        return ApiService.api.deleteProductCollections(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationProductCollection(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ProductCollectionModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ProductCollectionModel, params?: RequestParams): Promise<CrudResponse<ProductCollectionModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getProductCollectionGroupped(query, params);
    }

}
